import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Clear from '@material-ui/icons/Clear';
import Info from '@material-ui/icons/Info';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import Edit from '@material-ui/icons/Edit';
import ExpandMore from '@material-ui/icons/ExpandMore';
import FilterNone from '@material-ui/icons/FilterNone';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import FilterList from '@material-ui/icons/FilterList';
import Search from '@material-ui/icons/Search';
import Send from '@material-ui/icons/Send';
import Done from '@material-ui/icons/Done';
import AccountCircle from '@material-ui/icons/AccountCircle';

import { Root } from './styled';


export type IconTypes<T = React.ReactNode>=  {
	'visibility': T;
	'visibility-off': T;
	'clear': T;
	'info': T;
	'chevron-left': T;
	'chevron-right': T;
	'add': T;
	'remove': T;
	'edit': T;
	'expand-more': T;
	'arrow-back': T;
	'arrow-forward': T;
	'arrow-drop-down': T;
	'result-success': T;
	'link-external': T;
	'file-copy': T;
	'filter-list': T;
	'search': T;
	'send': T;
	'done': T;
	'account-circle': T;
	'list-placeholder': T;
	'notification': T;
}

export type IconColors = 'white' | 'danger' | 'black' | 'primary' | 'muted';

export type IconProps = {
	type: keyof IconTypes;
	width?: number;
	height?: number;
	color?: IconColors;
	onClick?: (e: React.SyntheticEvent) => void;
}

const iconRealizationMap = {
	'visibility': () => <Visibility />,
	'visibility-off': () => <VisibilityOff />,
	'clear': () => <Clear />,
	'info': () => <Info />,
	'chevron-left': () => <ChevronLeft />,
	'chevron-right': () => <ChevronRight />,
	'add': () => <Add />,
	'remove': () => <Remove />,
	'edit': () => <Edit />,
	'expand-more': () => <ExpandMore />,
	'file-copy': () => <FilterNone />,
	'arrow-back': () => <ArrowBack />,
	'arrow-forward': () => <ArrowForward />,
	'arrow-drop-down': () => <ArrowDropDown />,
	'filter-list': () => <FilterList />,
	'search': () => <Search />,
	'send': () => <Send />,
	'done': () => <Done />,
	'account-circle': () => <AccountCircle />,
	'result-success': () => (
		<SvgIcon
			width='104px'
			height='104px'
			viewBox='0 0 104 104'>
			<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g transform='translate(-658.000000, -2213.000000)' strokeWidth='3' stroke='currentColor'>
					<g transform='translate(500.000000, 1986.000000)'>
						<path d='M243.73146,242.215245 C234.838601,234.011448 222.956156,229 209.903226,229 C182.342435,229 160,251.342435 160,278.903226 C160,306.464016 182.342435,328.806452 209.903226,328.806452 L209.903226,328.806452 C237.464016,328.806452 259.806452,306.464016 259.806452,278.903226 C259.806452,273.237786 258.862359,267.792851 257.122917,262.717162 M181.806452,273.451613 L206.967742,298.612903 L259,243'></path>
					</g>
				</g>
			</g>
		</SvgIcon>
	),
	'link-external': () => {
		return (
			<SvgIcon
				width="7px"
				height="7px"
				viewBox="0 0 7 7">
				<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g transform="translate(-423.000000, -577.000000)" fill='currentColor' className='icon-fill-content'>
						<g transform="translate(78.000000, 200.000000)">      
							<g transform="translate(40.000000, 369.000000)">
								<g transform="translate(305.000000, 8.000000)">
									<path d="M4.37509843,8.75000002e-05 L7,8.75000002e-05 L7,2.6250875 L6.12503281,2.6250875 L6.12503281,1.4937125 L3.37238604,4.2473375 L2.75290927,3.6278375 L5.50555604,0.8750875 L4.37509843,0.8750875 L4.37509843,8.75000002e-05 Z M0,0 L2.62490157,0 L2.62490157,0.875 L0.874967189,0.875 L0.874967189,6.125 L6.12477032,6.125 L6.12477032,4.375 L6.99973751,4.375 L6.99973751,7 L6.12477032,7 L0.874967189,7 L0,7 L0,6.125 L0,0.875 L0,0 Z"></path>
								</g>
							</g>
						</g>
					</g>
				</g>
			</SvgIcon>
		);
	},
	'list-placeholder': () => {
		return (
			<SvgIcon
				width="61px"
				height="55px"
				viewBox="0 0 61 55">
				<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-661.000000, -614.000000)">
					<g transform="translate(662.000000, 615.000000)">
						<g>
							<circle stroke='currentColor' strokeWidth="2" cx="32" cy="42" r="11"></circle>
							<path d="M35.5732422,42.4516602 C35.5732422,44.0385822 35.3022488,45.2177696 34.7602539,45.9892578 C34.218259,46.760746 33.3710995,47.1464844 32.21875,47.1464844 C31.081049,47.1464844 30.2387723,46.7692909 29.6918945,46.0148926 C29.1450168,45.2604943 28.8618165,44.1337966 28.8422852,42.6347656 L28.8422852,40.8256836 C28.8422852,39.2582929 29.1132785,38.0937538 29.6552734,37.3320312 C30.1972683,36.5703087 31.0468692,36.1894531 32.2041016,36.1894531 C33.3515682,36.1894531 34.1962864,36.5568811 34.7382812,37.291748 C35.2802761,38.026615 35.5585937,39.1606369 35.5732422,40.6938477 L35.5732422,42.4516602 Z M34.2182617,40.5986328 C34.2182617,39.4511661 34.0571305,38.6149929 33.7348633,38.0900879 C33.412596,37.5651829 32.9023472,37.3027344 32.2041016,37.3027344 C31.5107387,37.3027344 31.0053727,37.5639622 30.6879883,38.0864258 C30.3706039,38.6088893 30.2070313,39.412104 30.1972656,40.4960938 L30.1972656,42.6640625 C30.1972656,43.816412 30.3645003,44.6672336 30.6989746,45.2165527 C31.0334489,45.7658719 31.5400357,46.0405273 32.21875,46.0405273 C32.8876987,46.0405273 33.3845199,45.7817409 33.7092285,45.2641602 C34.0339372,44.7465794 34.2036132,43.9311579 34.2182617,42.8178711 L34.2182617,40.5986328 Z" id="0" fill='currentColor'></path>
							<g transform="translate(19.000000, 24.000000) rotate(-11.000000) translate(-19.000000, -24.000000) translate(4.000000, 3.000000)" stroke='currentColor' strokeWidth="2">
								<polyline points="22 0 22 9 30 9"></polyline>
								<path d="M5,15 L25,15"></path>
								<path d="M5,20 L25,20"></path>
								<path d="M5,25 L25,25"></path>
								<polyline points="30 31.6059568 30 9 22 0 0 0 0 0 0 42 12.9562655 42"></polyline>
								<path d="M6,15 L6,25"></path>
								<path d="M15,15 L15,25"></path>
								<path d="M24,15 L24,25"></path>
							</g>
							<g transform="translate(41.731397, 24.476306) rotate(11.000000) translate(-41.731397, -24.476306) translate(26.731397, 3.476306)" stroke='currentColor' strokeWidth="2">
								<polyline points="22 0 22 9 30 9"></polyline>
								<path d="M5,15 L25,15"></path>
								<path d="M6.93814946,20 L25,20"></path>
								<path d="M8.87382162,24.7617379 L25,25"></path>
								<polyline points="19.3705828 42 30 42 30 9 22 0 0 0 0 7.16027087"></polyline>
								<path d="M6,15 L5.19328629,16.3087112"></path>
								<path d="M15,15 L15,25"></path>
								<path d="M24,15 L24,25"></path>
							</g>
						</g>
					</g>
				</g>
			</SvgIcon>
		);
	},
	'notification': () => {
		return (
			<SvgIcon
				width="15px"
				height="17px"
				viewBox="0 0 15 17">
				<g fill="none" fillRule="evenodd">
					<path fill='currentColor' fillOpacity="0" d="M-5-4h24v24H-5z"/>
					<path fill="#999" fillRule="nonzero" d="M7.286 17C8.229 17 9 16.235 9 15.3H5.571c0 .935.772 1.7 1.715 1.7zm5.571-5.1V7.225c0-2.635-1.8-4.76-4.286-5.355v-.595C8.571.595 7.971 0 7.286 0 6.6 0 6 .595 6 1.275v.595c-2.486.595-4.286 2.72-4.286 5.355V11.9L0 13.6v.85h14.571v-.85l-1.714-1.7z"/>
				</g>
			</SvgIcon>
		);
	},
};

const getIcon = (type: keyof IconTypes<React.ReactNode>): (p?) => React.ReactNode => iconRealizationMap[type];

const Icon: React.SFC<IconProps> = (props) => {
	const {
		type,
		width,
		height,
		color,
		...rest
	} = props;

	return (
		<Root
			width={width}
			height={height}
			color={color}
			{...rest}>
			{getIcon(type)()}
		</Root>
	);
}


Icon.displayName = 'Icon';
Icon.defaultProps = {
	width: 20,
	height: 20,
	color: 'muted'
};

export {
	iconRealizationMap
};

export default Icon;
